"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.MoreInfoModal = exports.IconButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("../Icons/obsolete/index"));

var _SlidingModal = _interopRequireDefault(require("./SlidingModal"));

var _Modal = _interopRequireDefault(require("./Modal.styled"));

var _Button = _interopRequireDefault(require("../Components/Button/Button"));

var _utilities = require("../GlobalStyle/utilities/utilities.styled");

var _utils = require("../utils");

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var IconButton = _styledComponents.default.button.withConfig({
  displayName: "IconButton",
  componentId: "sc-q0rpnn-0"
})(["cursor:pointer;display:inline-flex;background:none;border:none;padding:0;svg{margin:0;}"]);

exports.IconButton = IconButton;

var MoreInfoModal = function MoreInfoModal(_ref) {
  var id = _ref.id,
      title = _ref.title,
      subTitle = _ref.subTitle,
      helpText = _ref.helpText,
      questionIconFlag = _ref.questionIconFlag,
      questionHyperLink = _ref.questionHyperLink,
      hyperLinKText = _ref.hyperLinKText;

  var _useState = (0, _react.useState)(!1),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0, _react.useState)(null),
      returnFocus = _useState2[0],
      setReturnFocus = _useState2[1];

  var toggleModal = function toggleModal() {
    setIsOpen(!isOpen);

    if (isOpen) {
      returnFocus.focus();
    } else {
      setReturnFocus(document.activeElement);
    }
  };

  var elemID = function genID() {
    return id || (0, _utils.getID)();
  }();

  if (!helpText) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !questionHyperLink && /*#__PURE__*/_react.default.createElement(IconButton, {
    type: "button",
    onClick: toggleModal
  }, questionIconFlag && /*#__PURE__*/_react.default.createElement(_index.default.Info, {
    color: "#2E5299"
  }), !questionIconFlag && /*#__PURE__*/_react.default.createElement(_index.default.Question, {
    color: "#2E5299"
  }), hyperLinKText && /*#__PURE__*/_react.default.createElement(_utilities.SROnly, null, hyperLinKText)), questionHyperLink && !questionIconFlag && /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: toggleModal,
    theme: "link"
  }, hyperLinKText), /*#__PURE__*/_react.default.createElement(_SlidingModal.default, {
    open: isOpen,
    onClose: toggleModal
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Wrapper, null, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    id: elemID + "-title",
    slidingPanel: !0
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Title, null, title), /*#__PURE__*/_react.default.createElement("br", null), subTitle), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
    id: elemID + "-desc"
  }, helpText))));
};

exports.MoreInfoModal = MoreInfoModal;
MoreInfoModal.propTypes = {
  id: _propTypes.default.string,
  title: _propTypes.default.string.isRequired,
  subTitle: _propTypes.default.string,
  helpText: _propTypes.default.node,
  questionIconFlag: _propTypes.default.bool,
  questionHyperLink: _propTypes.default.bool,
  hyperLinKText: _propTypes.default.string
};
MoreInfoModal.defaultProps = {
  questionIconFlag: !1,
  questionHyperLink: !1
};